import { removeRedirectUrl, removeStoredAuthState } from "../util";

import { AuthLogoutRequestAction } from "../actions/AuthLogout";
import { AuthState } from "../state";

export function authLogout(initialState: AuthState) {
    return (state: AuthState, action: AuthLogoutRequestAction): AuthState => {
        removeRedirectUrl();
        removeStoredAuthState();

        return { ...initialState };
    };
}
